class MHeader extends HTMLElement{constructor(){super(),this.selectors={headers:["header"],logos:[".m-logo"],topbar:".m-topbar",headerWrapper:".m-header__wrapper",topbarClose:".m-topbar__close"},this.domNodes=queryDomNodes(this.selectors,this),this.innerWidth=window.innerWidth,this.headerOffsetTop=this.domNodes.headerWrapper.offsetTop,this.headerHeight=this.domNodes.headerWrapper.offsetHeight,this.stickyHeader=this.dataset.sticky,this.classes={scrollUp:"scroll-up",scrollDown:"scroll-down",stuck:"stuck",always:"header-sticky-always",headerScrollUp:"header-scroll-up",headerScrollDown:"header-scroll-down"},this.init()}init(){this.transparentHeader=this.domNodes&&this.domNodes.headers[0]&&"true"===this.domNodes.headers[0].dataset.transparent,this.initAddon(),this.handleSticky(),document.addEventListener("matchMobile",(()=>this.handleSticky())),document.addEventListener("unmatchMobile",(()=>this.handleSticky())),this.siteNav=new SiteNav(this),window.__sfHeader=this,window.addEventListener("resize",(()=>{this.innerWidth=window.innerWidth}))}initAddon(){this.megamenu=new Megamenu(this),Shopify.designMode&&(MinimogTheme=MinimogTheme||{},MinimogTheme&&MinimogTheme.Wishlist&&MinimogTheme.Wishlist.updateWishlistCount())}handleSticky(){let s=20;document.querySelectorAll(".shopify-section-group-header-group").forEach((e=>{e.classList.contains("m-section-header")||e.classList.contains("m-section-scaling-logo")||(s+=e.offsetHeight)}));const e=document.querySelector(".m-topbar");e&&(s+=e.offsetHeight);let t=0;window.addEventListener("scroll",(()=>{const e=window.scrollY;if(e<=s)return this.classList.remove(this.classes.scrollUp,this.classes.stuck,this.classes.always),void document.body.classList.remove(this.classes.headerScrollUp,this.classes.headerScrollDown);"on_scroll_up"===this.stickyHeader?this.classList.add(this.classes.stuck):"always"===this.stickyHeader&&this.classList.add(this.classes.always),e>this.headerHeight+s&&e>t&&!this.classList.contains(this.classes.scrollDown)?(this.classList.remove(this.classes.scrollUp),document.body.classList.remove(this.classes.headerScrollUp),this.classList.add(this.classes.scrollDown),document.body.classList.add(this.classes.headerScrollDown)):e<t&&this.classList.contains(this.classes.scrollDown)&&(this.classList.remove(this.classes.scrollDown),document.body.classList.remove(this.classes.headerScrollDown),this.classList.add(this.classes.scrollUp),document.body.classList.add(this.classes.headerScrollUp)),t=e}))}}customElements.define("m-header",MHeader);

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.m-sub-menu__item').forEach(item => {
        item.addEventListener('mouseenter', function(){
            document.querySelectorAll('.m-sub-menu__item').forEach(element => {
                element.classList.remove('active');
            })
            item.classList.add('active');
            let menuTitle = item.dataset.menuTitle;
            document.querySelectorAll('.m-mega-menu__content .m-mega-collection-list')?.forEach(content => {
                if(content.dataset.contentTitle == menuTitle){
                    content.classList.remove('hidden');
                }else{
                    content.classList.add('hidden');
                }
            })

            document.querySelectorAll('.m-mega-collection-list__wrapper .m-mega-collection-list')?.forEach(content => {
                if(content.dataset.contentTitle == menuTitle){
                    content.classList.remove('hidden');
                }else{
                    content.classList.add('hidden');
                }
            })
            
        })
    })
});

document.querySelectorAll('.m-menu-mobile__toggle-button').forEach(item => {
    item.addEventListener('click', function () {
        let menuLevel = item.getAttribute("data-toggle-submenu");
        item.closest('.m-menu-mobile__item').querySelector('.m-megamenu-mobile--level-' + menuLevel).classList.add('open');
        document.querySelector('.m-header__mobile .m-menu-drawer__backdrop').classList.add('hidden');
        document.querySelector('.m-header__mobile .mobile-search-container').classList.add('hidden');        
    })
})

document.querySelectorAll('.m-menu-mobile__back-button').forEach(button => {
    button.addEventListener('click', function() {
        let menuLevel = this.getAttribute("data-level");
        let parentItem = this.closest('.m-menu-mobile__item'); 
        if (parentItem) {
            let submenu = parentItem.querySelector('.m-megamenu-mobile--level-' + menuLevel);
            if (submenu) {
                submenu.classList.remove('open');
            }
        }
        if(menuLevel == 1) {
            document.querySelector('.m-header__mobile .m-menu-drawer__backdrop').classList.remove('hidden');
            document.querySelector('.m-header__mobile .mobile-search-container').classList.remove('hidden');        }
    });
});


document.querySelectorAll('.m-menu__selector').forEach(selectItem => {
    selectItem.addEventListener('mouseenter', () => {
        selectItem.querySelector('.grandchild').classList.add('active');
    })
    selectItem.addEventListener('mouseleave', () => {
        selectItem.querySelector('.grandchild').classList.remove('active');
    })
})

// Accordion functionality for second-level mobile menu items
document.querySelectorAll('[data-accordion-toggle]').forEach(header => {
    header.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const accordionItem = this.closest('.m-menu-mobile__item--accordion');
        const isActive = accordionItem.classList.contains('active');

        // Close all other accordions at the same level
        const parentSubmenu = accordionItem.closest('.m-submenu-mobile');
        if (parentSubmenu) {
            parentSubmenu.querySelectorAll('.m-menu-mobile__item--accordion').forEach(item => {
                if (item !== accordionItem) {
                    item.classList.remove('active');
                }
            });
        }

        // Toggle current accordion
        if (isActive) {
            accordionItem.classList.remove('active');
        } else {
            accordionItem.classList.add('active');
        }
    });
})

// Open first accordion in each second-level nav modal by default
document.querySelectorAll('.m-megamenu-mobile--level-1').forEach(modal => {
    const firstAccordion = modal.querySelector('.m-menu-mobile__item--accordion');
    if (firstAccordion) {
        firstAccordion.classList.add('active');
    }
})
